
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6acf00a0!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TaskDetailsHeader.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TaskDetailsHeader.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6acf00a0!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TaskDetailsHeader.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/copyrighter/taskManagement/TaskDetailsHeader.vue
// module id = 1061
// module chunks = 0